import { Component, Input, OnInit } from '@angular/core';
import { FormGroup} from '@angular/forms';
@Component({
  selector: 'app-validation-error',
  templateUrl: './validation-error.component.html',
  styleUrls: ['./validation-error.component.scss'],
})
export class ValidationErrorComponent implements OnInit {
  @Input() validationMessage:{};
  @Input() fieldName:String
  _validationForm:FormGroup
  
  
  constructor() { }
  
  ngOnInit() {
    
  }
  @Input()
  set validationForm(val: FormGroup) {
    this._validationForm = val;
  }

}
